<template>
    <div class="publish-actions-container">
        <square-button v-if="showRedirectButton"
                       :disabled="element.data.readonly"
                       :size="size"
                       :tooltip-delay="650"
                       :tooltip-text="t_edit_inline"
                       icon="fas fa-pencil"
                       @click="redirectTo" />
        <square-button v-if="showConvertLinkButton"
                       :disabled="element.data.readonly"
                       :size="size"
                       :tooltip-delay="650"
                       :tooltip-text="t_local_copy"
                       icon="fas fa-link-simple-slash"
                       @click="convertLink" />
        <square-button v-if="showCopyButton"
                       :disabled="element.data.readonly"
                       :size="size"
                       :tooltip-delay="650"
                       :tooltip-text="t_copy"
                       icon="fas fa-clone"
                       @click="createCopy" />
        <square-button v-if="showDeleteButton"
                       :buttonClasses="element.deleted_at ? [] : ['button-red-on-hover']"
                       :disabled="element.data.readonly || deleteDisabled"
                       :icon="deleteButtonIcon"
                       :size="size"
                       :tooltip-delay="650"
                       :tooltip-text="deleteButtonText"
                       :loading="loadingDeletionState"
                       @click="element.deleted_at ? unDelete(): softDelete()" />
    </div>
</template>

<script>
import SquareButton from '../common/squareButton.vue'

export default {
    name: 'actions',
    components: { SquareButton },
    props: {
        /** @type {PublishElement} */
        element: {
            type: Object,
            required: true
        },
        /** @type {'1' | undefined} */
        editPrivilege: String,
        /** @type {'1' | undefined} */
        deletePrivilege: String,
        size: String,
        loadingDeletionState: Boolean,
        deleteDisabled: Boolean
    },
    data: function() {
        return {
            t_edit_inline: Lang.langGet('Edit Element Inline'),
            t_local_copy: Lang.langGet('Create Local Copy'),
            t_copy: Lang.langGet('Create copy'),
            t_delete: Lang.langGet('Delete'),
            t_mark_delete: Lang.langGet('Mark for Deletion'),
            t_unmark_delete: Lang.langGet('Unmark for Deletion')
        }
    },
    computed: {
        showRedirectButton() {
            if (this.element?.state === 'fulldelete') return false;
            return this.element.data.type === 'template' || this.element.data.type === 'campaign'
        },
        showConvertLinkButton() {
            return this.element.data.state === 'link'
        },
        showCopyButton() {
            if (this.element?.state === 'deleted') return false;
            if (this.element?.state === 'tobedeleted') return false;
            if (this.element?.state === 'fulldelete') return false;
            return this.editPrivilege;
        },
        showDeleteButton() {
            if (this.element?.state === 'fulldelete') return false;
            return this.deletePrivilege;
        },
        deleteButtonIcon() {
            return `fas ${!this.element.published_at ? 'fa-trash' : this.element.deleted_at ? 'fa-trash-slash' : 'fa-trash-check'}`
        },
        deleteButtonText() {
            return !this.element.published_at ? this.t_delete : this.element.deleted_at ? this.t_unmark_delete : this.t_mark_delete
        }
    },
    methods: {
        redirectTo() {
            if (this.element.data.readonly === false) {
                this.$emit('redirectTo')
            }
        },
        convertLink() {
            if (this.element.data.readonly === false) {
                this.$emit('convertLink')
            }
        },
        createCopy() {
            if (this.element.data.readonly === false) {
                this.$emit('createCopy')
            }
        },
        softDelete() {
            if (this.element.data.readonly === false) {
                this.$emit('softDelete')
            }
        },
        unDelete() {
            if (this.element.data.readonly === false) {
                this.$emit('unDelete')
            }
        }
    }
}
</script>

<style>
.publish-actions-container {
    display: flex;
    gap: 4px;
}
</style>
